export const StatusCode = Object.freeze({
  BAD_REQUEST: 400,
  CONFLICT: 409,
  CREATED: 201,
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500,
  NOT_ALLOWED: 405,
  NOT_FOUND: 404,
  NO_CONTENT: 204,
  OK: 200,
  UNAUTHORIZED: 401,
});
